"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8711],{

/***/ 58711:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./src/providers/LayoutRegisterProvider.tsx
var LayoutRegisterProvider = __webpack_require__(63085);
// EXTERNAL MODULE: ./src/providers/LayoutConfigProvider.tsx + 1 modules
var LayoutConfigProvider = __webpack_require__(64002);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/styles/theme.ts + 3 modules
var theme = __webpack_require__(68251);
// EXTERNAL MODULE: ./src/styles/designs.ts
var designs = __webpack_require__(73098);
// EXTERNAL MODULE: ./src/hooks/useMediaQuery.ts
var useMediaQuery = __webpack_require__(10763);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 109 modules
var motion = __webpack_require__(81041);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 2 modules
var AnimatePresence = __webpack_require__(14332);
// EXTERNAL MODULE: ./src/components/TrackedLink.tsx
var TrackedLink = __webpack_require__(79017);
// EXTERNAL MODULE: ./src/components/common/Button/index.tsx + 8 modules
var Button = __webpack_require__(78296);
// EXTERNAL MODULE: ./src/components/icons/ChevronRight.tsx
var ChevronRight = __webpack_require__(38108);
// EXTERNAL MODULE: ./src/components/icons/Close.tsx
var Close = __webpack_require__(34039);
// EXTERNAL MODULE: ./src/components/common/DirectusImage.tsx
var DirectusImage = __webpack_require__(52520);
// EXTERNAL MODULE: ./vendor/mods/markdown/components/Markdown.tsx
var Markdown = __webpack_require__(15201);
// EXTERNAL MODULE: ./src/styles/common.ts
var common = __webpack_require__(12258);
;// CONCATENATED MODULE: ./src/modules/announcement/components/AnnouncementContent.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  height: 100%;\n  padding: 15px 14px 18px 30px;\n  ",
        " {\n    flex-wrap: wrap;\n    width: 100%;\n    padding: 10px 22px 13px;\n  }\n  ",
        " {\n    padding: 15px 30px 18px 14px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  height: 100%;\n  ",
        " {\n    margin-bottom: 6px;\n    height: auto;\n    width: 100%;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n  min-width: 55px;\n  max-width: 55px;\n  height: 33px;\n  margin-top: 1px;\n  ",
        " {\n    min-width: 73rpx;\n    max-width: 73rpx;\n    height: calc(100% + 33px);\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  opacity: 0.5;\n  min-width: 1rpx;\n  height: 16px;\n  background: ",
        ";\n  margin: 0 0 0 15px;\n  ",
        " {\n    height: 10px;\n    margin: 0 15px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  max-width: 420px;\n  font-size: 14px;\n  line-height: 16px;\n  color: ",
        ";\n  overflow: hidden;\n  ",
        " {\n    margin-left: 15px;\n    margin-right: 24px;\n    max-height: 100%;\n    max-height: 54px;\n  }\n  p {\n    margin: 0;\n    ",
        "\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  && {\n    display: flex;\n    min-width: 150px;\n    padding-left: 25px;\n    padding-right: 25px;\n    ",
        " {\n      width: calc(100% - 50px);\n      min-height: 32px;\n      height: 32px;\n      margin-right: 10px;\n      ",
        " {\n        margin-right: 0;\n        margin-left: 10px;\n      }\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: 10px;\n  min-width: 32px;\n  max-width: 32px;\n  height: 32px;\n  overflow: hidden;\n  ",
        " {\n    margin-left: auto;\n    svg {\n      width: 19px;\n      height: 19px;\n    }\n  }\n  ",
        " {\n    margin-left: 0;\n    margin-right: 10px;\n    ",
        " {\n      margin-right: auto;\n    }\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}














var Wrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "AnnouncementContent__Wrapper",
    componentId: "sc-39eab8ff-0"
})(_templateObject(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop, theme/* dirRTL */.gX);
var Content = styled_components_browser_esm["default"].div.withConfig({
    displayName: "AnnouncementContent__Content",
    componentId: "sc-39eab8ff-1"
})(_templateObject1(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var Logo = styled_components_browser_esm["default"].div.withConfig({
    displayName: "AnnouncementContent__Logo",
    componentId: "sc-39eab8ff-2"
})(_templateObject2(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var Spacer = styled_components_browser_esm["default"].span.withConfig({
    displayName: "AnnouncementContent__Spacer",
    componentId: "sc-39eab8ff-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.text.palette.primary;
}, designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var Text = styled_components_browser_esm["default"].div.withConfig({
    displayName: "AnnouncementContent__Text",
    componentId: "sc-39eab8ff-4"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.text.palette.primary;
}, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop, (0,common/* lineClamp */.Sf)(3));
var CTAButton = (0,styled_components_browser_esm["default"])(Button/* Button */.zx).withConfig({
    displayName: "AnnouncementContent__CTAButton",
    componentId: "sc-39eab8ff-5"
})(_templateObject5(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop, theme/* dirRTL */.gX);
var CloseButton = (0,styled_components_browser_esm["default"])(Button/* Button */.zx).withConfig({
    displayName: "AnnouncementContent__CloseButton",
    componentId: "sc-39eab8ff-6"
})(_templateObject6(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop, theme/* dirRTL */.gX, designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var AnnouncementContent = function(param) {
    var image = param.image, description = param.description, ctaLabel = param.ctaLabel, ctaLink = param.ctaLink;
    var layoutRegisterContext = (0,react.useContext)(LayoutRegisterProvider/* LayoutRegisterContext */.D);
    var layoutConfigContext = (0,react.useContext)(LayoutConfigProvider/* LayoutConfigContext */.x);
    var handleClose = (0,react.useCallback)(function() {
        layoutConfigContext === null || layoutConfigContext === void 0 ? void 0 : layoutConfigContext.hideLayoutComponent("announcement");
        layoutRegisterContext === null || layoutRegisterContext === void 0 ? void 0 : layoutRegisterContext.deregisterComponent("desktopAnnouncement");
        layoutRegisterContext === null || layoutRegisterContext === void 0 ? void 0 : layoutRegisterContext.deregisterComponent("mobileAnnouncement");
    }, [
        layoutRegisterContext,
        layoutConfigContext
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                children: [
                    (image === null || image === void 0 ? void 0 : image.id) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DirectusImage/* DirectusImage */.q, {
                                    src: image.id,
                                    layout: "fill",
                                    quality: 100,
                                    objectFit: "contain"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacer, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                            children: description
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TrackedLink/* TrackedLink */.A, {
                href: ctaLink,
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CTAButton, {
                    forwardedAs: "a",
                    icon: ChevronRight/* ChevronRight */._,
                    iconProps: {
                        position: "right"
                    },
                    children: ctaLabel
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton, {
                kind: "text",
                icon: Close/* Close */.x,
                iconProps: {
                    size: 14
                },
                onClick: handleClose
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/utils/motion/transitions.ts
var transitions = __webpack_require__(84176);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 6 modules
var polished_esm = __webpack_require__(17573);
// EXTERNAL MODULE: ./src/modules/announcement/hooks/useAnnouncement.ts + 2 modules
var useAnnouncement = __webpack_require__(65015);
;// CONCATENATED MODULE: ./src/modules/announcement/components/index.tsx



function components_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  width: 100%;\n  max-width: 100vw;\n  min-height: ",
        "px;\n  z-index: 50;\n  display: flex;\n  justify-content: flex-end;\n  pointer-events: none;\n  ",
        " {\n    min-height: ",
        "px;\n  }\n"
    ]);
    components_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function components_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: ",
        "px;\n  background: ",
        ";\n  pointer-events: all;\n  ",
        " {\n    min-height: ",
        "px;\n    clip-path: polygon(16rpx 0, 100% 0, 100% 100%, 0% 100%);\n    max-width: 70vw;\n    ",
        " {\n      clip-path: polygon(0 0, calc(100% - 16rpx) 0, 100% 100%, 0% 100%);\n    }\n  }\n"
    ]);
    components_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function components_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    height: ",
        "px;\n  }\n"
    ]);
    components_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}













var desktopHeight = 75;
var mobileHeight = 98;
var FixedContainer = (0,styled_components_browser_esm["default"])(motion/* motion.div */.E.div).withConfig({
    displayName: "components__FixedContainer",
    componentId: "sc-dfc4db46-0"
})(components_templateObject(), mobileHeight, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop, desktopHeight);
var components_Wrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "components__Wrapper",
    componentId: "sc-dfc4db46-1"
})(components_templateObject1(), mobileHeight, function(param) {
    var $background = param.$background;
    return "linear-gradient(267.17deg, ".concat((0,polished_esm/* darken */._j)(0.2, $background), " -0.08%, ").concat((0,polished_esm/* lighten */.$n)(0.1, $background), " 98.8%)");
}, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop, desktopHeight, theme/* dirRTL */.gX);
var MobilePlaceholder = styled_components_browser_esm["default"].div.withConfig({
    displayName: "components__MobilePlaceholder",
    componentId: "sc-dfc4db46-2"
})(components_templateObject2(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop, mobileHeight);
var Announcement = function() {
    var announcement = (0,useAnnouncement/* useAnnouncement */.q)();
    var layoutRegisterContext = (0,react.useContext)(LayoutRegisterProvider/* LayoutRegisterContext */.D);
    var layoutConfigContext = (0,react.useContext)(LayoutConfigProvider/* LayoutConfigContext */.x);
    var isDesktop = (0,useMediaQuery/* useMediaQuery */.a)(designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
    var isVisible = !!(layoutConfigContext === null || layoutConfigContext === void 0 ? void 0 : layoutConfigContext.announcement) && announcement;
    (0,react.useEffect)(function() {
        if (isVisible) {
            if (isDesktop) {
                layoutRegisterContext === null || layoutRegisterContext === void 0 ? void 0 : layoutRegisterContext.registerComponent({
                    id: "desktopAnnouncement",
                    placement: "footer",
                    position: "fixed",
                    height: desktopHeight
                });
            } else {
                layoutRegisterContext === null || layoutRegisterContext === void 0 ? void 0 : layoutRegisterContext.registerComponent({
                    id: "mobileAnnouncement",
                    placement: "footer",
                    position: "fixed",
                    height: mobileHeight
                });
                layoutRegisterContext === null || layoutRegisterContext === void 0 ? void 0 : layoutRegisterContext.registerComponent({
                    id: "mobileAnnouncementPlaceholder",
                    placement: "footer",
                    position: "static",
                    height: mobileHeight
                });
            }
            return function() {
                layoutRegisterContext === null || layoutRegisterContext === void 0 ? void 0 : layoutRegisterContext.deregisterComponent("desktopAnnouncement");
                layoutRegisterContext === null || layoutRegisterContext === void 0 ? void 0 : layoutRegisterContext.deregisterComponent("mobileAnnouncement");
            };
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isDesktop,
        isVisible
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_components_browser_esm.ThemeProvider, {
        theme: theme/* redTheme */.MN,
        children: [
            isVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(MobilePlaceholder, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                initial: false,
                children: isVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(FixedContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,transitions/* makeTransition */.Vr)({
                    from: "bottom",
                    to: "bottom",
                    fade: true,
                    enterDelay: 0.2
                })), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Wrapper, {
                        $background: announcement.background,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AnnouncementContent, (0,_object_spread/* default */.Z)({}, announcement))
                    })
                }))
            })
        ]
    });
};
/* harmony default export */ var components = (Announcement);


/***/ })

}]);